import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerFrenteOrden = styled(motion.div)`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 10px;
  align-items: center;

  img {
    width: 120px;
    object-fit: contain;
  }

  .container-btn {
    display: flex;
    gap: 20px;
  }

  button {
    width: 140px;
    height: 53px;
    border-radius: 8px;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    color: var(--color-white);
  }
  span {
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
  }
`;

export const ContainerSeleccionarOrdenes = styled(ContainerFrenteOrden)`
  .container-images {
    position: relative;
    .second-image {
      position: absolute;
      left: 30px;
      top: 20px;
    }
  }
  .container-btn {
    margin-top: 20px;
  }
`;
export const ContainerCantidadOrdenes = styled(ContainerSeleccionarOrdenes)`
  .container-btn-selection {
    button {
      color: var(--color-latex30);
    }
    height: 100px;
    display: flex;
    gap: 30px;
    justify-content: center;
    align-items: flex-end;
  }
  .selection {
    background-color: transparent;
    border-radius: 100%;
    width: 60px;
    height: 60px;
    border: 2px solid var(--color-latex30);
    font-style: normal;
    font-weight: 500;
    font-size: 32px;
    line-height: 150%;
    color: var(--color-latex10);
  }
  .active {
    @keyframes selection-animation {
      0% {
        background-color: transparent;
        border-radius: 100%;
        width: 70px;
        height: 70px;
        border: 2px solid var(--color-latex30);
        font-style: normal;
        font-weight: 500;
        font-size: 32px;
        line-height: 150%;
        color: var(--color-latex10);
      }
      100% {
        background-color: var(--color-latex30);
        border-radius: 100%;
        width: 70px;
        height: 70px;
        border: 2px solid var(--color-latex30);
        font-style: normal;
        font-weight: 500;
        font-size: 32px;
        line-height: 150%;
        color: var(--color-white);
      }
    }

    background-color: var(--color-latex30);
    color: var(--color-white);
    animation: selection-animation 1s forwards;
  }

  .container-avanzar {
    margin-top: 40px;
  }
`;

export const ContainerSubirOrden = styled(ContainerSeleccionarOrdenes)`
  .subtitle {
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
  }

`;


export const ConfirmarImagen = styled(ContainerSeleccionarOrdenes)`
img {
    width: 120px;
    height: 200px; 
    object-fit: contain;
  }
`; 